
import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import {
  addDocChamber,
  doctorList,
  editDocChamber,
  getShopOwnerList,
  removeDocChamber,
  updateDoctorData
} from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setWeek } from "date-fns";


const Doctor = () => {
  const [doctors, setDoctors] = useState([]);
  const token = useSelector((state) => state.user.token);
  const navigate = useNavigate();

  const [selectedDoc, setSelectedDoc] = useState(null);
  const[availableDay,setAvailableDay] = useState(null);
  const[weekOfMonth,setWeekOfMonth]=useState([])
  const[startTime,setStartTime] = useState(null);
  const[endTime,setEndTime] = useState(null);

  const[chamberEditingMode,setChamberEditingMode]=useState(false)

  const [shopList, setShopList] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");

  const [editprofession, setEditprofession] = useState("");
  const [editSpecialization, setEditSpecialization] = useState("");
  const [editDegree, setEditDegree] = useState("");
  const [editrelationWithCo, setEditrelationWithCo] = useState("");
  const [editnumberOfCo, setEditnumberOfCo] = useState("");
  const [editadharimage, setEditadharimage] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentDoctors = doctors.slice(indexOfFirst, indexOfLast);

  const [editmodal, setEditModal] = useState(false);

  const handleFetchShop = async () => {
    try {
      const response = await getShopOwnerList(token);
      console.log(response);
      setShopList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDoctorList = async () => {
    try {
      const response = await doctorList(token);
      setDoctors(response);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    handleFetchShop();
    fetchDoctorList();
  }, []);

  const handleCommesionRole = () => {
    navigate("/doctor-commesion");
  };

  const handleAddChamber = async () => {
    

    if (Number(selectedValue) === 0 || !availableDay||!startTime||!endTime) {
      alert("Complete the form to add chamber")
      return;
    }

    let body = {
      doctorId: selectedDoc.id,
      shopId: Number(selectedValue),
      availableDay,
      startTime,
      endTime,weekOfMonth
    };

    console.log(body);

    try {
      const response = await addDocChamber({ body, token });
      console.log(response);

      if (response.status === 200) {
        toast.success("New Chamber Added");
        handleFetchShop();
        fetchDoctorList();
        setSelectedDoc(null);
        setSelectedValue("");
        setAvailableDay(null)
        setStartTime(null)
        setEndTime(null)
        setWeekOfMonth([])
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleEditChamber = async () => {
    
console.log("Editing chambers--------------------------");

    if (Number(selectedValue) === 0 || !availableDay||!startTime||!endTime) {
      alert("Complete the form to add chamber")
      return;
    }

    let body = {
      doctorId: selectedDoc.id,
      chamberId: Number(selectedValue),
      availableDay,
      startTime,
      endTime,
      weekOfMonth
    };

    console.log(body);

    try {
      const response = await editDocChamber({ body, token });
      console.log(response);

      if (response.status === 200) {
        toast.success(" Chamber Edited");
        handleFetchShop();
        fetchDoctorList();
        setSelectedDoc(null);
        setSelectedValue("");
        setAvailableDay(null)
        setStartTime(null)
        setEndTime(null)
        setChamberEditingMode(false)
         setWeekOfMonth([])
      }
    } catch (error) {
      console.log(error);
    }
  };
     
  const handleRemoveChamber = async (id) => {
    
console.log("remove chambers--------------------------");

    if (Number(id) === 0 ) {
      
      return;
    }

  

    try {
      const response = await removeDocChamber(id, token );
      console.log(response);

      if (response.status === 200) {
        toast.success("Chamber Removed");
        handleFetchShop();
        fetchDoctorList();
        setSelectedDoc(null);
        setSelectedValue("");
        setAvailableDay(null)
        setStartTime(null)
        setEndTime(null)
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (editmodal && selectedDoc) {
      setEditprofession(selectedDoc.profession);
      setEditSpecialization(selectedDoc.specialization);
      setEditDegree(selectedDoc.degree);
      setEditrelationWithCo(selectedDoc.relationWithCo);
      setEditnumberOfCo(selectedDoc.numberOfCo);
      setEditadharimage(selectedDoc.aadhaarImage);
    }
  }, [selectedDoc, editmodal]);

  const habdleEditDoctor = async () => {
    try {
      let data = {
        doctorId: selectedDoc.id,
        profession: editprofession,
        specialization: editSpecialization,
        degree: editDegree,
        relationWithCo: editrelationWithCo,
        numberOfCo: editnumberOfCo,
        aadhaarImage: editadharimage,
        token: token
      };

      const response = await updateDoctorData(data);
      console.log("edit doc", response);

      if (response.status === 200) {
        fetchDoctorList();
        toast.success("Doctor Data Updated Successfully");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error while updating doctor data");
    } finally {
      setEditModal(false);
      setSelectedDoc(null);
    }
  };

  const closeViewModal = () => {
    setSelectedDoc(null);
    setSelectedValue("");
  };

  const openEditModal = (doctor) => {
    setSelectedDoc(doctor);
    setEditModal(true);
  };

  const closeEditModal = () => {
    setEditModal(false);
    setSelectedDoc(null);
  };

  const totalPages = Math.ceil(doctors.length / itemsPerPage);

  return (
    <div id="main_content">
      <Header />

      <div className="page">
        <Section />

        <div className="doctor-page">

          {/* Page Header */}
          <div className="doctor-page-header">
            <div>
              <div className="doctor-breadcrumb">
                <span>Dashboard</span>
                <i className="fa fa-angle-right" />
                <span>Management</span>
                <i className="fa fa-angle-right" />
                <span className="doctor-breadcrumb-active">Doctors</span>
              </div>

              <h1>Doctor Management</h1>
              <p>
                View doctor profiles, manage chamber associations and update
                professional information.
              </p>
            </div>

            <button
              onClick={handleCommesionRole}
              className="doctor-commission-btn"
            >
              <i className="fa fa-percent" />
              Commission Management
              <i className="fa fa-arrow-right doctor-btn-arrow" />
            </button>
          </div>

          {/* Summary Cards */}
          <div className="doctor-stats-grid">
            <div className="doctor-stat-card">
              <div className="doctor-stat-icon doctor-stat-red">
                <i className="fa fa-user-md" />
              </div>
              <div>
                <span>Total Doctors</span>
                <h3>{doctors.length}</h3>
                <small>Registered doctors</small>
              </div>
            </div>

            <div className="doctor-stat-card">
              <div className="doctor-stat-icon doctor-stat-blue">
                <i className="fa fa-hospital" />
              </div>
              <div>
                <span>Available Chambers</span>
                <h3>{shopList.length}</h3>
                <small>Listed shops / chambers</small>
              </div>
            </div>

            <div className="doctor-stat-card">
              <div className="doctor-stat-icon doctor-stat-green">
                <i className="fa fa-stethoscope" />
              </div>
              <div>
                <span>Current Page</span>
                <h3>{doctors.length ? currentPage : 0}</h3>
                <small>Page {totalPages || 0} total</small>
              </div>
            </div>
          </div>

          {/* Doctors Table Panel */}
          <div className="doctor-table-panel">
            <div className="doctor-table-header">
              <div>
                <h3>
                  <span className="doctor-heading-icon">
                    <i className="fa fa-users" />
                  </span>
                  Registered Doctors
                </h3>
                <p>Doctor directory and professional details</p>
              </div>

              <div className="doctor-record-count">
                <i className="fa fa-database" />
                {doctors.length} Records
              </div>
            </div>

            <div className="doctor-table-wrapper">
              {currentDoctors.length > 0 ? (
                <div className="table-responsive">
                  <table className="doctor-table">
                    <thead>
                      <tr style={{color:"white"}}>
                        <th className="doctor-center">ID</th>
                        <th>Doctor</th>
                        <th>Gender</th>
                        <th>Contact Number</th>
                        <th>Profession</th>
                        <th>Specialization</th>
                        <th>State</th>
                        <th className="doctor-center">Chamber</th>
                        <th className="doctor-center">Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentDoctors.map((doctor, index) => (
                        <tr key={doctor.id}>
                          <td className="doctor-center">
                            <span className="doctor-row-id">
                              {indexOfFirst + index + 1}
                            </span>
                          </td>

                          <td>
                            <div className="doctor-name-cell">
                              <div className="doctor-avatar">
                                {doctor.firstName?.charAt(0)?.toUpperCase() || "D"}
                              </div>
                              <div className="doctor-name-details">
                                <strong>
                                  {doctor.firstName} {doctor.middleName}{" "}
                                  {doctor.lastName}
                                </strong>
                                <small>Doctor ID: {doctor.id}</small>
                              </div>
                            </div>
                          </td>

                          <td>
                            <span className="doctor-gender">
                              {doctor.gender || "—"}
                            </span>
                          </td>

                          <td>
                            <span className="doctor-phone">
                              <i className="fa fa-phone" />
                              {doctor.primaryNumber || "—"}
                            </span>
                          </td>

                          <td>
                            <span className="doctor-profession">
                              {doctor.profession || "—"}
                            </span>
                          </td>

                          <td>
                            <span className="doctor-specialization">
                              {doctor.specialization || "—"}
                            </span>
                          </td>

                          <td>
                            <span className="doctor-state">
                              <i className="fa fa-map-marker-alt" />
                              {doctor.state || "—"}
                            </span>
                          </td>

                          <td>
                            <div className="doctor-actions">
                              <button
                                onClick={() => {
                                  setSelectedDoc(doctor);
                                  setSelectedValue("");
                                }}
                                className="doctor-action-btn doctor-view-btn"
                                title="View doctor"
                              >
                               <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="1.8"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M3 21h18" />
  <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
  <path d="M9 7h6" />
  <path d="M12 4v6" />
  <path d="M9 14h.01M15 14h.01" />
  <path d="M9 18h6" />
</svg>
                              </button>

                              
                            </div>
                          </td>
                          <td>
                            <div className="doctor-actions">
                              <button
                                onClick={() => openEditModal(doctor)}
                                className="doctor-action-btn doctor-edit-btn"
                                title="Edit doctor"
                              >
                                <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M12 20h9" />
  <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4Z" />
</svg>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="doctor-empty-state">
                  <div className="doctor-empty-icon">
                    <i className="fa fa-user-md" />
                  </div>
                  <h3>No doctors found</h3>
                  <p>Registered doctors will appear here.</p>
                </div>
              )}
            </div>

            {/* Pagination */}
            {doctors.length > 0 && (
              <div className="doctor-pagination">
                <div className="doctor-pagination-info">
                  Showing{" "}
                  <strong>{indexOfFirst + 1}</strong> to{" "}
                  <strong>{Math.min(indexOfLast, doctors.length)}</strong> of{" "}
                  <strong>{doctors.length}</strong> doctors
                </div>

                <div className="doctor-pagination-controls">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="doctor-page-btn"
                  >
                    <i className="fa fa-chevron-left" />
                    Prev
                  </button>

                  <span className="doctor-page-number">
                    {currentPage} / {totalPages}
                  </span>

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="doctor-page-btn"
                  >
                    Next
                    <i className="fa fa-chevron-right" />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* VIEW DOCTOR MODAL */}
        {selectedDoc && !editmodal && (
          <div
            className="doctor-modal-overlay"
            onClick={closeViewModal}
          >
            <div
              className="doctor-modal doctor-view-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="doctor-modal-header">
                <div className="doctor-modal-heading">
                  <div className="doctor-modal-icon">
                    <i className="fa fa-user-md" />
                  </div>
                  <div>
                    <h3>Doctor Profile</h3>
                    <p>View doctor information and manage chambers</p>
                  </div>
                </div>

                <button
                  className="doctor-modal-close"
                  onClick={closeViewModal}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="doctor-modal-body">

                {/* Profile Section */}
                <div className="doctor-profile-banner">
                  <div className="doctor-profile-avatar">
                    {selectedDoc.firstName?.charAt(0)?.toUpperCase() || "D"}
                  </div>

                  <div className="doctor-profile-info">
                    <h2>
                      {selectedDoc.firstName} {selectedDoc.middleName}{" "}
                      {selectedDoc.lastName}
                    </h2>
                    <p>
                      {selectedDoc.profession || "Profession not specified"}
                    </p>
                    <span>
                      <i className="fa fa-id-card" />
                      Doctor ID: {selectedDoc.id}
                    </span>
                  </div>

                  <div className="doctor-profile-age">
                    <strong>{selectedDoc.age || "—"}</strong>
                    <span>Age</span>
                  </div>
                </div>

                {/* Details */}
                <div className="doctor-details-section">
                  <h4>
                    <i className="fa fa-address-card" />
                    Personal Information
                  </h4>

                  <div className="doctor-details-grid">
                    <div className="doctor-detail-item">
                      <span>Gender</span>
                      <strong>{selectedDoc.gender || "—"}</strong>
                    </div>

                    <div className="doctor-detail-item">
                      <span>Contact Number</span>
                      <strong>{selectedDoc.primaryNumber || "—"}</strong>
                    </div>

                    <div className="doctor-detail-item doctor-detail-full">
                      <span>Address</span>
                      <strong>
                        {selectedDoc.houseBuildingApartment || ""}
                        {selectedDoc.villageTownCity
                          ? `, ${selectedDoc.villageTownCity}`
                          : ""}
                        {selectedDoc.state ? `, ${selectedDoc.state}` : ""}
                      </strong>
                    </div>

                    <div className="doctor-detail-item">
                      <span>Profession</span>
                      <strong>{selectedDoc.profession || "—"}</strong>
                    </div>

                    <div className="doctor-detail-item">
                      <span>Specialization</span>
                      <strong>{selectedDoc.specialization || "—"}</strong>
                    </div>

                    <div className="doctor-detail-item">
                      <span>Degree</span>
                      <strong>{selectedDoc.degree || "—"}</strong>
                    </div>

                    <div className="doctor-detail-item">
                      <span>Relation With Company</span>
                      <strong>{selectedDoc.relationWithCo || "—"}</strong>
                    </div>

                    <div className="doctor-detail-item">
                      <span>Number Of Company</span>
                      <strong>{selectedDoc.numberOfCo || "—"}</strong>
                    </div>
                  </div>
                </div>

                {/* Chamber Section */}
                <div className="doctor-chamber-section">
                  <div className="doctor-section-title">
                    <div>
                      <h4>
                        <i className="fa fa-hospital" />
                        Chambers
                      </h4>
                      <p>Manage this doctor's chamber associations</p>
                    </div>

                    <span className="doctor-chamber-count">
                      {selectedDoc.chambers?.length || 0} Chambers
                    </span>
                  </div>

                  <div className="doctor-add-chamber">
                           <label htmlFor="doctor-chamber-select"
                           onClick={()=>navigate('/chamber-add')}
                           style={{color:"white",backgroundColor:"#0e6299",padding:"4px",width:"fit-content",borderRadius:"4px",cursor:"pointer"}}>
                      Add New Chamber
                        <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="1.8"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M3 21h18" />
  <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
  <path d="M9 7h6" />
  <path d="M12 4v6" />
  <path d="M9 14h.01M15 14h.01" />
  <path d="M9 18h6" />
</svg>
                    </label>
                          {
                            chamberEditingMode && <p>Editing   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M12 20h9" />
                                  <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" />
                                </svg></p>
                          }


                    <label htmlFor="doctor-chamber-select">
                      Select Chamber
                    </label>

                    <select
                      id="doctor-chamber-select"
                      className="doctor-chamber-select"
                      value={selectedValue}
                      onChange={(e) => setSelectedValue(e.target.value)}
                    >
                      <option value="">Select a chamber</option>

                      {shopList.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.shopName}
                        </option>
                      ))}
                    </select>
                    <div className="doctor-form-group">
                    <label>Day</label>
                    <select
                      id="doctor-chamber-select"
                      className="doctor-chamber-select"
                      value={availableDay}
                      onChange={(e) => setAvailableDay(e.target.value)}
                    >
                      <option value="">Select a day</option>

                      {['MONDAY','TUESDAY','WEDNESDAY','THUSDAY','FRIDAY','SATURDAY','SUNDAY'].map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </div>
                    <div className="doctor-form-group">
  <label>Week of Month</label>

  <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
    {[
      "FIRST","SECOND","THIRD","FOURTH"
    ].map((day) => (
      <label
        key={day}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
        }}
      >
        <input
          type="checkbox"
          checked={weekOfMonth.includes(day)}
          onChange={(e) => {
            if (e.target.checked) {
              setWeekOfMonth((prev) => [...prev, day]);
            } else {
              setWeekOfMonth((prev) => prev.filter((d) => d !== day));
            }
          }}
        />
        {day}
      </label>
    ))}
  </div>
</div>
                  <div className="doctor-form-group">
                    <label>Start time</label>
                    <input
                    value={startTime}
                    onChange={(e)=>setStartTime(e.target.value)}
                    type="time"
                    />
                  </div>
                  <div className="doctor-form-group">
                    <label>End time</label>
                    <input
                    value={endTime}
                    onChange={(e)=>setEndTime(e.target.value)}
                    type="time"
                    />
                  </div>
                                  
                       <div className="doctor-form-group"> <button
                       style={{margin:"8px 0px"}}
                  className="doctor-primary-btn"
                  onClick={() =>chamberEditingMode?handleEditChamber(): handleAddChamber()}
                >
                  
                {chamberEditingMode?"Edit": "Submit"}
                </button>
                </div>
                  </div>

                  <div className="doctor-chamber-list">
                    {selectedDoc.chambers?.length > 0 ? (
                      selectedDoc.chambers.map((item, i) => (
                        <div className="doctor-chamber-item" key={item.id || i}
                        style={{display:"flex",justifyContent:"space-between"}}>
                          <div className="doctor-chamber-number">
                            {i + 1}
                          </div>

                          <div>
                            <strong>{item?.shopName}</strong>
                            <p>
                              <i className="fa fa-map-marker-alt" />
                              {item?.shopAddress}
                            </p>
                          </div>
                          <div>
                            <p>{item?.availableDay}</p>
                            <p><span>{item?.startTime[0]}{" "}:{" "}{item?.startTime[1]}</span>{"  -  "}
                            <span>{item?.endTime[0]}{" "}:{" "}{item?.endTime[1]}</span>
                            </p>

                            </div>
                            <div>
                            
                            <p><span
                            style={{cursor:"pointer",margin:"0px 4px"}}
                            onClick={()=>{
                              setSelectedValue(item.id)
                              setAvailableDay(item?.availableDay)
                              setWeekOfMonth(item?.weekOfMonth||[])
                             setStartTime(
                                 `${String(item?.startTime?.[0] ?? 0).padStart(2, "0")}:${String(item?.startTime?.[1] ?? 0).padStart(2, "0")}`
                                );
                              setEndTime(
                             `${String(item?.endTime?.[0] ?? 0).padStart(2, "0")}:${String(item?.endTime?.[1] ?? 0).padStart(2, "0")}`
                            );  
                            setChamberEditingMode(true)                          
                            }}
                            >
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 20h9" />
  <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" />
</svg>
                            </span>
                            <span  style={{cursor:"pointer",margin:"0px 4px"}}
                            onClick={()=>{handleRemoveChamber(item.doctorChamberMappingId)
                                setSelectedValue(item.id)}}>
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M3 6h18" />
  <path d="M8 6V4h8v2" />
  <path d="m19 6-1 14H6L5 6" />
  <path d="M10 11v5M14 11v5" />
</svg>
                            </span>
                            </p>

                            </div>
                        </div>
                      ))
                    ) : (
                      <div className="doctor-no-chambers">
                        <i className="fa fa-hospital" />
                        <span>No chambers added yet.</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="doctor-modal-footer">
                <button
                  className="doctor-secondary-btn"
                  onClick={closeViewModal}
                >
                  Close
                </button>


              </div>
            </div>
          </div>
        )}

        {/* EDIT DOCTOR MODAL */}
        {editmodal && selectedDoc && (
          <div
            className="doctor-modal-overlay"
            onClick={closeEditModal}
          >
            <div
              className="doctor-modal doctor-edit-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="doctor-modal-header">
                <div className="doctor-modal-heading">
                  <div className="doctor-modal-icon">
                    <i className="fa fa-user-edit" />
                  </div>

                  <div>
                    <h3>Edit Doctor Information</h3>
                    <p>
                      Update professional details for{" "}
                      {selectedDoc.firstName} {selectedDoc.lastName}
                    </p>
                  </div>
                </div>

                <button
                  className="doctor-modal-close"
                  onClick={closeEditModal}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="doctor-modal-body">
                <div className="doctor-edit-notice">
                  <i className="fa fa-info-circle" />
                  Update the doctor's professional information below.
                </div>

                <div className="doctor-edit-form">
                  <div className="doctor-form-group">
                    <label>Profession</label>
                    <input
                      type="text"
                      value={editprofession || ""}
                      onChange={(e) => setEditprofession(e.target.value)}
                      placeholder="Enter profession"
                    />
                  </div>

                  <div className="doctor-form-group">
                    <label>Specialization</label>
                    <input
                      type="text"
                      value={editSpecialization || ""}
                      onChange={(e) =>
                        setEditSpecialization(e.target.value)
                      }
                      placeholder="Enter specialization"
                    />
                  </div>

                  <div className="doctor-form-group">
                    <label>Degree</label>
                    <input
                      type="text"
                      value={editDegree || ""}
                      onChange={(e) => setEditDegree(e.target.value)}
                      placeholder="Enter degree"
                    />
                  </div>

                  <div className="doctor-form-group">
                    <label>Relation With Company</label>
                    <input
                      type="text"
                      value={editrelationWithCo || ""}
                      onChange={(e) =>
                        setEditrelationWithCo(e.target.value)
                      }
                      placeholder="Enter relation with company"
                    />
                  </div>

                  <div className="doctor-form-group">
                    <label>Number Of Company</label>
                    <input
                      type="text"
                      value={editnumberOfCo || ""}
                      onChange={(e) =>
                        setEditnumberOfCo(e.target.value)
                      }
                      placeholder="Enter number of company"
                    />
                  </div>

                  <div className="doctor-form-group doctor-form-full">
                    <label>Aadhaar Image</label>

                    <div className="doctor-file-input-wrapper">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          setEditadharimage(e.target.files[0])
                        }
                      />
                      <span>
                        <i className="fa fa-cloud-upload-alt" />
                        Choose Aadhaar image
                      </span>
                    </div>

                    <small>
                      {editadharimage instanceof File
                        ? editadharimage.name
                        : editadharimage
                        ? "Existing Aadhaar image is set"
                        : "No image selected"}
                    </small>
                  </div>
                </div>
              </div>

              <div className="doctor-modal-footer">
                <button
                  className="doctor-secondary-btn"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>

                <button
                  className="doctor-primary-btn"
                  onClick={habdleEditDoctor}
                >
                  <i className="fa fa-save" />
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">
                    Technology support By - Siance Software Pvt Ltd
                  </a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Doctor;
